'use client';
import useSWR from 'swr';
import { API_URLS, SWR_REQUEST_DEFAULTS } from '@/lib/api/config';
import { TypeProduct } from '../types';

type PlayKitSubscriptionProductParams = {
  language?: string | undefined;
};

export default function usePlayKitSubscriptionProduct(
  params: PlayKitSubscriptionProductParams,
) {
  const { language } = params;

  const queryParams = new URLSearchParams({
    anchor: 'subscription-1',
    enable_redux: 'true',
    include_associations:
      'products,products.assets,products.metadata,products.products,products.products.assets,products.products.variants,products.products.variants.assets',
  });

  if (language) {
    queryParams.append('language', language);
  }

  const playKitSubscriptionProductUrl = `${API_URLS.PRODUCT_CATALOG_PROXY}/product?${queryParams}`;

  const {
    data: playKitSubscriptionProductData,
    isLoading: isLoadingPlayKitSubscriptionProduct,
    error: playKitSubscriptionProductError,
    mutate: mutatePlayKitSubscriptionProduct,
  } = useSWR<TypeProduct, Error>(
    playKitSubscriptionProductUrl,
    SWR_REQUEST_DEFAULTS,
  );

  return {
    data: playKitSubscriptionProductData,
    loading: isLoadingPlayKitSubscriptionProduct,
    error: playKitSubscriptionProductError,
    mutate: mutatePlayKitSubscriptionProduct,
  };
}
